import KeywordService from 'src/modules/keyword/keywordService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'KEYWORD_VIEW';

const keywordViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: keywordViewActions.FIND_STARTED,
      });

      const record = await KeywordService.find(id);

      dispatch({
        type: keywordViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: keywordViewActions.FIND_ERROR,
      });

      getHistory().push('/keyword');
    }
  },
};

export default keywordViewActions;
